import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";

export enum ModalTypes {
  UPLOAD_MODAL = URLSearchParamKeys.UPLOAD_MODAL,
  RENAME_TRACK = URLSearchParamKeys.RENAME_TRACK_MODAL,
  TRACK_VIEW = URLSearchParamKeys.TRACK_VIEW_MODAL,
  TRACK_INFO = URLSearchParamKeys.TRACK_INFO_MODAL,
  CREATE_PLAYLIST = URLSearchParamKeys.CREATE_PLAYLIST_MODAL,
  RENAME_PLAYLIST = URLSearchParamKeys.RENAME_PLAYLIST_MODAL,
  CREATE_SEGMENT = URLSearchParamKeys.CREATE_SEGMENT_MODAL,
  EDIT_SEGMENT = URLSearchParamKeys.EDIT_SEGMENT_MODAL,
  EXPORT_SEGMENTS = URLSearchParamKeys.EXPORT_SEGMENTS_MODAL,
  CREATE_POINT = URLSearchParamKeys.CREATE_POINT_MODAL,
  EDIT_POINT = URLSearchParamKeys.EDIT_POINT_MODAL,
  POINT_PREVIEW = URLSearchParamKeys.POINT_PREVIEW_MODAL,
  EDIT_TRACK_TAG = URLSearchParamKeys.TAG_MODAL,
  SHARE_TRACK = URLSearchParamKeys.SHARE_TRACK_MODAL,
  SHARE_SEGMENT = URLSearchParamKeys.SHARE_SEGMENT_MODAL,
  COPY_TRACK = URLSearchParamKeys.COPY_TRACK,
  MOVE_TRACK = URLSearchParamKeys.MOVE_TRACK,
  MOVE_PLAYLIST = URLSearchParamKeys.MOVE_PLAYLIST,
  USER_PROFILE = URLSearchParamKeys.USER_PROFILE,
  CREATE_BAND_WORKSPACE = URLSearchParamKeys.CREATE_BAND_WORKSPACE,
  EDIT_BAND_WORKSPACE = URLSearchParamKeys.EDIT_BAND_WORKSPACE,
  SHARE_TRACK_WITH_WORKSPACE = URLSearchParamKeys.SHARE_TRACK_WITH_WORKSPACE,
}

export type ModalStateType = {
  x: number,
  y: number,
  width: number,
  height: number,
  minimized: boolean,
  maximized: boolean,
} | null
